import { useEffect } from "react";
import { Helmet } from "react-helmet";

export default function FBWAAttendeeRegistration() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//embed.typeform.com/next/embed.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <Helmet>
        <title>FBWA Attendee Registration</title>
        <meta
          name='description'
          content="Partner with us — let's grow your business together."
        />
        <meta property='og:title' content='FBWA Attendee Registration' />
        <meta
          property='og:description'
          content="Partner with us — let's grow your business together."
        />
      </Helmet>
      <div
        data-tf-live='01JX5NTBXYA95RVZTVZRHC65HR'
        data-tf-transitive-search-params='utm_source,utm_medium,utm_campaign,utm_term,utm_content,fbclid,fbc,ttclid'
        style={{ width: "100%", height: "100dvh" }}
        //   data-tf-on-ready='onDistributorFormReady'
        //   data-tf-on-submit='onDistributorFormSubmit'
        //   data-tf-on-started='onDistributorFormStarted'
        //   data-tf-on-ending-button-click='onDistributorFormEndButtonClicked'
        //   data-tf-on-question-changed='onDistributorFormQuestionChanged'
      />
    </div>
  );
}
